import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { i18n } from './plugins/i18n'
import './style.css'

// Initialize Pinia and app
const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)

// Initialize authentication
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()

// PWA registration (disabled in development)
// Note: PWA is disabled in development mode to avoid service worker caching issues

// Initialize auth and mount app
const initApp = async () => {
  try {
    await authStore.checkAuth()
    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize app:', error)
    app.mount('#app')
  }
}

initApp()
